import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { AB_CURRENCY_FORMAT } from '../constants';

@Pipe({
  name: 'abMoney'
})
export class AbMoneyPipe extends DecimalPipe implements PipeTransform {
  transform(value: string | number): any {
    return super.transform(value, AB_CURRENCY_FORMAT);
  }
}
